import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { verificationService } from '../services/verification.service';

interface DeleteVerificationData {
  candidateId: string;
  experienceId: string;
  verificationId: string;
}

export function useDeleteVerification(): {
  deleteVerification: UseMutateFunction<void, Error, DeleteVerificationData>;
  deleteVerificationAsync: (data: DeleteVerificationData) => Promise<unknown>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: DeleteVerificationData) =>
      verificationService.deleteVerification(
        data.candidateId,
        data.experienceId,
        data.verificationId
      ),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          'verifications',
          { candidateId: variables.candidateId, experienceId: variables.experienceId },
        ],
      });
    },
  });

  return {
    deleteVerification: mutation.mutate,
    deleteVerificationAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
}
